/* Filtrous account chip v1 (2026-08-03) — replaces the header "Sign in" link
   with an initial avatar + name when the customer is signed in, matching the
   checkout header ("E · ABDA Labs"). Works in BOTH header chromes:
     - .fh3-actions a.signin  (sections/filtrous-header.liquid, non-app pages)
     - .fv3-actions a.signin  (header built by filtrous-v3.js on app pages)
   Login state comes from the Section Rendering API
   (sections/filtrous-customer-state.liquid): full pages are CDN-cached and may
   be rendered logged-out, so page Liquid can't be trusted for session state.
   Additive asset — remove the loader line in sections/filtrous-header.liquid
   to revert. */
(function () {
  'use strict';
  if (window.__fAcctChip) return;
  window.__fAcctChip = 1;

  var state = null;

  function displayName(s) {
    if (s.company) return s.company;
    var n = ((s.first_name || '') + ' ' + (s.last_name || '')).trim();
    if (n) return n;
    return (s.email || '').split('@')[0];
  }

  function injectCSS() {
    if (document.getElementById('facct-css')) return;
    var st = document.createElement('style');
    st.id = 'facct-css';
    st.textContent =
      '.signin .facct-avatar{display:inline-flex !important;align-items:center;justify-content:center;' +
      'width:24px;height:24px;border-radius:50%;background:var(--navy,#082F4B);color:#fff;' +
      'font-size:12px;font-weight:700;line-height:1;flex:none;}' +
      '.signin.facct-on{gap:8px;}' +
      /* fh3 mobile hides .signin span; keep the avatar visible there */
      '@media (max-width:820px){.fh3-actions .signin .facct-avatar{display:inline-flex !important;}}';
    document.head.appendChild(st);
  }

  function apply() {
    if (!state || !state.logged_in) return;
    var links = document.querySelectorAll('.fh3-actions a.signin, .fv3-actions a.signin');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-facct')) continue;
      a.setAttribute('data-facct', '1');
      a.classList.add('facct-on');
      a.setAttribute('href', '/account');
      a.setAttribute('aria-label', 'Account');
      var name = displayName(state);
      var initial = (name.charAt(0) || 'A').toUpperCase();
      a.innerHTML = '<span class="facct-avatar"></span><span class="facct-name"></span>';
      a.querySelector('.facct-avatar').textContent = initial;
      a.querySelector('.facct-name').textContent = name;
    }
  }

  function boot() {
    injectCSS();
    apply();
    // The fv3 header is injected async by filtrous-v3.js — keep watching.
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  fetch('/?sections=filtrous-customer-state', { credentials: 'same-origin', cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var html = j && j['filtrous-customer-state'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.getElementById('fn-customer-state');
      if (!node) return;
      try { state = JSON.parse(node.textContent); } catch (e) { return; }
      if (!state.logged_in) return;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
      else boot();
    })
    .catch(function () { /* fail open: header keeps "Sign in" */ });
})();
